import styled from "styled-components";
import { WinnerIcon } from "app/components/React/Table/cells/LeaderDefaultCell";
import { FlexRow, RightFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { SortComponent } from "app/components/React/Table/headerCells/DefaultCellHeader";
import { PopupHoverContainer } from "@similarweb/ui-components";
import { ChangeValue } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";

const NO_CURRENT_POSITION_SIGN = "-";

const getTextForFirstPart = (currentPosition: string) =>
    translate("position.filter.tooltip.part1", { currentPosition });
const getTextForSecondPart = (previousPosition: string, date: string) =>
    translate("position.filter.tooltip.part2", { previousPosition, date });
import { DomainCellWithoutTooltip } from "app/components/React/Table/cells/DomainCell";

const StyledFlex = styled(FlexRow)`
    overflow: hidden;
    .headerCell-sortDirection {
        margin-left: 0;
    }
`;

const Text = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
`;

export const DomainPositionCellHeader = (domain) => (props) => {
    return (
        <StyledFlex alignItems="center">
            {props.sortable && <SortComponent sortDirection={props.sortDirection} />}
            <DomainCellWithoutTooltip
                {...props}
                field={domain}
            />
        </StyledFlex>
    );
};
const WinnerIconStyled = styled(WinnerIcon)`
    transform: translateY(-1px);
`;

const DomainPositionCellText = styled.span<{ isLeader?: boolean }>`
    font-weight: ${({ isLeader }) => (isLeader ? 500 : 400)};
    margin-left: ${({ isLeader }) => (isLeader ? 5 : 0)}px;
`;

interface IDomainPositionCellProps {
    currentPosition: number | string;
    previousPosition: number | string;
    latMonthInShortMonthAndYear: string;
}

export const getPopupHoverContainerText = ({
    currentPosition,
    previousPosition,
    latMonthInShortMonthAndYear,
}: IDomainPositionCellProps) => {
    if (currentPosition === NO_CURRENT_POSITION_SIGN || (!currentPosition && !previousPosition)) {
        return translate("position.filter.tooltip.not.ranking");
    }
    if (!previousPosition) {
        return translate("position.filter.tooltip.current.rank", {
            currentPosition,
            latMonthInShortMonthAndYear,
        });
    }
    if (!currentPosition && previousPosition) {
        return translate("position.filter.tooltip.lost.rank", {
            previousPosition,
            latMonthInShortMonthAndYear,
        });
    }
    const changeSinceLastMonth = (previousPosition as number) - (currentPosition as number);
    if (!changeSinceLastMonth) {
        return translate("position.filter.tooltip.no.change", {
            currentPosition,
            latMonthInShortMonthAndYear,
        });
    }
    return (
        <>
            {getTextForFirstPart(currentPosition?.toString())}
            <ChangeValue
                value={`${Math.abs(changeSinceLastMonth)}`}
                isDecrease={changeSinceLastMonth < 0}
            />
            {getTextForSecondPart(previousPosition?.toString(), latMonthInShortMonthAndYear)}
        </>
    );
};

export const DomainPositionCell =
    (domain,latMonth) =>
    ({ row }) => {
        const currentPosition = row.CurrentPosition[domain] || NO_CURRENT_POSITION_SIGN;
        const previousPosition = row.PreviousPosition[domain];
        const { latMonthInShortMonthAndYear } = row;
        const isLeader = row.PositionLeader.domain === domain;
        return (
            <PopupHoverContainer
                content={() => (
                    <Text>
                        {getPopupHoverContainerText({
                            currentPosition,
                            previousPosition,
                            latMonthInShortMonthAndYear: latMonth ?? latMonthInShortMonthAndYear,
                        })}
                    </Text>
                )}
                config={{ placement: "top" }}
            >
                <RightFlexRow>
                    {isLeader && <WinnerIconStyled iconName="winner" />}
                    <DomainPositionCellText isLeader={isLeader}>{currentPosition}</DomainPositionCellText>
                </RightFlexRow>
            </PopupHoverContainer>
        );
    };
